import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WompiRelayService {

  private _baseUrl: string = "";
  private _controllerName: string = "";

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "WompiWebhookRelay"
  }

  /**
   * Crea una nueva URL de relay
   */
  insert(payload: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}`, payload).pipe(catchError(this.handleErrors))
  }

  /**
   * Actualiza una URL de relay existente
   */
  update(id: number, payload: any): Observable<any> {
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}`, payload).pipe(catchError(this.handleErrors))
  }

  /**
   * Elimina una URL de relay (soft delete)
   */
  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  /**
   * Obtiene todas las URLs de relay
   */
  getAll(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/`).pipe(catchError(this.handleErrors))
  }

  /**
   * Obtiene solo las URLs activas
   */
  getActive(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/active`).pipe(catchError(this.handleErrors))
  }

  /**
   * Obtiene una URL de relay por ID
   */
  getById(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  /**
   * Activa o desactiva una URL de relay
   */
  toggleActivation(id: number): Observable<any> {
    return this._http.patch<any>(`${this._baseUrl}/${this._controllerName}/${id}/toggle`, {}).pipe(catchError(this.handleErrors))
  }

  /**
   * Obtiene logs filtrados de relay
   */
  getLogs(filter: any): Observable<any> {
    const params = this.buildQueryParams(filter);
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/logs${params}`).pipe(catchError(this.handleErrors))
  }

  /**
   * Obtiene logs de relay para una URL específica con filtros y paginación server-side
   */
  getLogsByUrlId(id: number, filter?: any): Observable<any> {
    const params = filter ? this.buildQueryParams(filter) : '';
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}/logs${params}`).pipe(catchError(this.handleErrors))
  }

  /**
   * Construye query params a partir de un objeto de filtro
   */
  private buildQueryParams(filter: any): string {
    const params: string[] = [];
    
    for (const key in filter) {
      if (filter.hasOwnProperty(key) && filter[key] !== null && filter[key] !== undefined && filter[key] !== '') {
        params.push(`${key}=${encodeURIComponent(filter[key])}`);
      }
    }
    
    return params.length > 0 ? `?${params.join('&')}` : '';
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Ocurrió un error", error.error.message);
    } else {
      console.log(`Ocurrió un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }

}

